/**
 * Plain-string CVSS severity color map, with the same Mantine token colors as
 * `cvssSeverityLevelColorMap` in `vulnerabilities.ts` but keyed on lowercase strings.
 */
export const cvssStringColorMap: Record<
  'critical' | 'high' | 'medium' | 'low' | 'none',
  string
> = {
  critical: 'dark-red',
  high: 'red',
  medium: 'orange',
  low: 'yellow',
  none: 'gray',
};
